import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ProjectActivityPage } from '@/features/social/project-activity-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Activité d'un projet (#52) : fil, réactions, commentaires, abonnement. Entrée : « Activité » de la vue d'ensemble. */
export const Route = createFileRoute('/$tenant/projects/$projectId/activity')({
  component: ProjectActivityRoute,
});

function ProjectActivityRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="overview"
      crumbs={[{ label: t('social.page.title') }]}
    >
      <ProjectActivityPage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
